import React, { useEffect, useState } from "react";
import { MdArrowForward } from "react-icons/md";
import styles from "./Hero.module.css";
import bannerImage from "../../../assets/images/banner-image.jpg";
import useHeroAPI from "../../../api/useHeroAPI";
import { useNavigate } from "react-router-dom";
import bannerimg from "../../../assets/images/bannerImage.avif";

interface Option {
  name: string;
  code: string;
}

type SearchTab = "vehicle" | "size";
interface HeroProps {
  code: string; // "TYRE" or "BATTERY"
}

export default function Hero({ code }: HeroProps) {
  const [activeTab, setActiveTab] = useState<SearchTab>("vehicle");
  const [typesPreDefinedState, setTypesPreDefinedState] = useState<any[]>([]);
  const [activeSegment, setActiveSegment] = useState<any>(null);
  const [makeOptions, setMakeOptions] = useState<Option[]>([]);
  const [modelOptions, setModelOptions] = useState<Option[]>([]);
  const [variantOptions, setVariantOptions] = useState<Option[]>([]);
  const [selectedMake, setSelectedMake] = useState<Option | null>(null);
  const [selectedModel, setSelectedModel] = useState<Option | null>(null);
  const [selectedVariant, setSelectedVariant] = useState<Option | null>(null);
  const [widthOptions, setWidthOptions] = useState<Option[]>([]);
  const [profileOptions, setProfileOptions] = useState<Option[]>([]);
  const [rimOptions, setRimOptions] = useState<Option[]>([]);
  const [productType, setProductType] = useState<any>(null);
  const [width, setWidth] = useState<Option | null>(null);
  const [profile, setProfile] = useState<Option | null>(null);
  const [rim, setRim] = useState<Option | null>(null);
  const { predefinedFunc } = useHeroAPI();
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_PATH;
  const isFilterlessSegment = code === "TYRE";
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();

    navigate(`${basePath}products`, {
      state: {
        productType: productType?.predefined_id,
        category_ids: [activeSegment?.predefined_id],
        tyreType: activeSegment,
        brand: activeTab === "vehicle" ? selectedMake : null,
        model: activeTab === "vehicle" ? selectedModel : null,
        variant: activeTab === "vehicle" ? selectedVariant : null,
        width: activeTab === "size" ? width : null,
        aspect: activeTab === "size" ? profile : null,
        rim: activeTab === "size" ? rim : null,
      },
    });
  };
  // console.log(handleSearch, "handlesearch<<<<");

  const fetchMakesForType = async (type: any) => {
    setMakeOptions([]);
    setModelOptions([]);
    setVariantOptions([]);
    setSelectedMake(null);
    setSelectedModel(null);
    setSelectedVariant(null);

    if (!type?.predefined_id) {
      return;
    }

    const payload = {
      entity_type: "MAKE",
      parent_id: type.predefined_id,
    };

    const response = await predefinedFunc(payload);
    const makeData = (response?.data?.data || [])
      .map((child: any) => ({
        name: child.name,
        code: child.predefined_id,
      }))
      .sort(sortOptions);

    setMakeOptions(makeData);
  };

  const fetchModelsForMake = async (makeValue: Option | null) => {
    setModelOptions([]);
    setVariantOptions([]);
    setSelectedModel(null);
    setSelectedVariant(null);

    if (!makeValue?.code) {
      return;
    }

    const payload = {
      entity_type: "MODEL",
      parent_id: makeValue.code,
    };

    const response = await predefinedFunc(payload);
    const modelData = (response?.data?.data || [])
      .map((child: any) => ({
        name: child.name,
        code: child.predefined_id,
      }))
      .sort(sortOptions);

    setModelOptions(modelData);
  };

  const fetchVariantsForModel = async (modelValue: Option | null) => {
    setVariantOptions([]);
    setSelectedVariant(null);

    if (!modelValue?.code) {
      return;
    }

    const payload = {
      entity_type: "VARIANT",
      parent_id: modelValue.code,
    };

    const response = await predefinedFunc(payload);
    const variantData = (response?.data?.data || [])
      .map((child: any) => ({
        name: child.name,
        code: child.predefined_id,
      }))
      .sort(sortOptions);

    setVariantOptions(variantData);
  };

  const loadVehicleTypes = async (parentID: number) => {
    const payload = {
      entity_type: "CATEGORY",
      categoryParentID: parentID,
    };

    const response = await predefinedFunc(payload);

    if (response?.status === 200) {
      const types = response?.data?.data || [];
      setTypesPreDefinedState(types);

      const defaultType =
        types.find(
          (type: any) =>
            type?.code === "TWO WHEELER" ||
            type?.code === "TYRE" ||
            type?.name?.toLowerCase().includes("two"),
        ) || types[0];

      setActiveSegment(defaultType || null);
      if (defaultType) {
        await fetchMakesForType(defaultType);
      }
    }
  };

  const fetchProductType = async (code: string) => {
    const payload = {
      entity_type: "PRODUCT-TYPE",
      code,
    };

    const response = await predefinedFunc(payload);
    // console.log(
    //   "requested code:",
    //   code,
    //   "raw response data:",
    //   response?.data?.data,
    // );
    if (response?.status === 200) {
      // const selectedProduct = response?.data?.data?.[0];
      const allTypes = response?.data?.data || [];

      // Don't trust that the API already filtered — explicitly match by code
      const selectedProduct =
        allTypes.find((p: any) => p?.code === code) ?? allTypes[0] ?? null;
      // console.log(selectedProduct, "selectedProduct>>>>>>>>>>>>>..");
      setProductType(selectedProduct ?? null);
      if (selectedProduct?.predefined_id) {
        loadVehicleTypes(selectedProduct.predefined_id);
      }
    }
  };
  useEffect(() => {
    if (code && isFilterlessSegment) {
      fetchProductType(code);
    }
  }, [code]);
  useEffect(() => {
    if (activeTab === "size" && isFilterlessSegment) {
      fetchWidthOptions();
      fetchProfileOptions();
      fetchRimOptions();
    }
  }, [activeTab]);
  const handleSegmentSelection = async (segment: any) => {
    setActiveSegment(segment);
    await fetchMakesForType(segment);
  };
  const handleMakeSelection = async (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const selectedValue =
      makeOptions.find(
        (option) => String(option.code) === event.target.value,
      ) || null;
    setSelectedMake(selectedValue);
    await fetchModelsForMake(selectedValue);
  };

  const handleModelSelection = async (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const selectedValue =
      modelOptions.find(
        (option) => String(option.code) === event.target.value,
      ) || null;
    setSelectedModel(selectedValue);
    await fetchVariantsForModel(selectedValue);
  };

  const handleVariantSelection = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const selectedValue =
      variantOptions.find(
        (option) => String(option.code) === event.target.value,
      ) || null;
    setSelectedVariant(selectedValue);
  };

  const fetchWidthOptions = async () => {
    const payload = { entity_type: "WIDTH" };
    const response = await predefinedFunc(payload);
    // const data = (response?.data?.data || []).map((child: any) => ({
    //   name: child.name,
    //   code: child.predefined_id,
    // }));
    const data = (response?.data?.data || [])
      .map((child: any) => ({
        name: child.name,
        code: child.predefined_id,
      }))
      .sort(sortOptions);
    setWidthOptions(data);
  };

  const fetchProfileOptions = async () => {
    const payload = { entity_type: "ASPECT" }; // profile == aspect ratio
    const response = await predefinedFunc(payload);
    const data = (response?.data?.data || [])
      .map((child: any) => ({
        name: child.name,
        code: child.predefined_id,
      }))
      .sort(sortOptions);
    setProfileOptions(data);
  };

  const fetchRimOptions = async () => {
    const payload = { entity_type: "RIM" };
    const response = await predefinedFunc(payload);
    const data = (response?.data?.data || [])
      .map((child: any) => ({
        name: child.name,
        code: child.predefined_id,
      }))
      .sort(sortOptions);
    setRimOptions(data);
  };

  const sortOptions = (a: any, b: any) => {
    const aName = String(a.name).trim();
    const bName = String(b.name).trim();

    const aNum = Number(aName);
    const bNum = Number(bName);

    const aIsNumber = !isNaN(aNum) && aName !== "";
    const bIsNumber = !isNaN(bNum) && bName !== "";

    // Numbers first
    if (aIsNumber && !bIsNumber) return -1;
    if (!aIsNumber && bIsNumber) return 1;

    // Both numbers
    if (aIsNumber && bIsNumber) {
      return aNum - bNum;
    }

    // Both text
    return aName.localeCompare(bName, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };
  return (
    <>
      {code === "TYRE" && (
        <section className={styles.heroSection}>
          {/* Background Graphic and Overlay */}

          <div className={styles.bgWrapper}>
            <div
              className={styles.bgImage}
              style={{
                // backgroundImage: `url('https://abbott.mechmiles.com/brand_logos/banner-image.jpg')`,
                backgroundImage: `url(${bannerimg})`,
              }}
            />

            <div className={styles.gradientOverlay} />
            {/* <div className="banner-image-wrapper">
          <Image
            src={
              url != undefined
                ? "https://abbott.mechmiles.com/brand_logos/banner-image.jpg"
                : bannerImage
            }
          />
        </div> */}
          </div>

          {isFilterlessSegment && (
            <div className={styles.contentContainer}>
              {/* Hero Left Content */}
              <div className={styles.heroTextContent}></div>

              {/* Hero Right Filter Form */}
              <div className={styles.widgetCard}>
                {/* Tab Selection */}
                <div className={styles.tabHeader}>
                  <button
                    onClick={() => setActiveTab("vehicle")}
                    className={`${styles.tabBtn} ${activeTab === "vehicle" ? styles.activeTab : ""}`}
                  >
                    SEARCH BY VEHICLE
                  </button>
                  <button
                    onClick={() => setActiveTab("size")}
                    className={`${styles.tabBtn} ${activeTab === "size" ? styles.activeTab : ""}`}
                  >
                    SEARCH BY SIZE
                  </button>
                </div>

                {/* Form Content */}
                <form onSubmit={handleSearch} className={styles.formContainer}>
                  {activeTab === "vehicle" ? (
                    <div>
                      <label className={styles.inputLabel}>
                        FIND THE RIGHT{" "}
                        {activeSegment?.name?.toUpperCase() || "VEHICLE"}
                      </label>
                      {/* <h3 className={styles.segmentTitle}>
                  Find the right{" "}
                  {activeSegment?.name?.toLowerCase() || "vehicle"}
                </h3> */}
                      <div className={styles.segmentWrapper}>
                        {typesPreDefinedState.map((item: any) => (
                          <button
                            key={item.predefined_id}
                            type="button"
                            onClick={() => handleSegmentSelection(item)}
                            className={`${styles.segmentBtn} ${
                              activeSegment?.predefined_id ===
                              item.predefined_id
                                ? styles.activeSegmentBtn
                                : ""
                            }`}
                          >
                            <img
                              src={
                                activeSegment?.predefined_id ===
                                item.predefined_id
                                  ? item.active_thumbnail
                                  : item.thumbnail
                              }
                              alt={item.name}
                              className={styles.segmentIcon}
                            />

                            <span>{item.name}</span>
                          </button>
                        ))}
                      </div>

                      <div className={styles.formGrid}>
                        <div className={styles.inputGroup}>
                          <label className={styles.inputLabel}>MAKE</label>
                          <select
                            value={selectedMake?.code || ""}
                            onChange={handleMakeSelection}
                            className={styles.selectInput}
                          >
                            <option value="">Select Make</option>
                            {makeOptions.map((option) => (
                              <option key={option.code} value={option.code}>
                                {option.name?.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className={styles.inputGroup}>
                          <label className={styles.inputLabel}>MODEL</label>
                          <select
                            value={selectedModel?.code || ""}
                            onChange={handleModelSelection}
                            className={styles.selectInput}
                            disabled={!selectedMake}
                          >
                            <option value="">Select Model</option>
                            {modelOptions.map((option) => (
                              <option key={option.code} value={option.code}>
                                {option.name?.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className={styles.inputGroup}>
                          <label className={styles.inputLabel}>VARIANT</label>
                          <select
                            value={selectedVariant?.code || ""}
                            onChange={handleVariantSelection}
                            className={styles.selectInput}
                            disabled={!selectedModel}
                          >
                            <option value="">Select Variant</option>
                            {variantOptions.map((option) => (
                              <option key={option.code} value={option.code}>
                                {option.name?.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <label className={styles.inputLabel}>
                        FIND THE RIGHT{" "}
                        {activeSegment?.name?.toUpperCase() || "BATTERY"}
                      </label>
                      <div className={styles.segmentWrapper}>
                        {typesPreDefinedState.map((item: any) => (
                          <button
                            key={item.predefined_id}
                            type="button"
                            onClick={() => handleSegmentSelection(item)}
                            className={`${styles.segmentBtn} ${
                              activeSegment?.predefined_id ===
                              item.predefined_id
                                ? styles.activeSegmentBtn
                                : ""
                            }`}
                          >
                            <img
                              src={
                                activeSegment?.predefined_id ===
                                item.predefined_id
                                  ? item.active_thumbnail
                                  : item.thumbnail
                              }
                              alt={item.name}
                              className={styles.segmentIcon}
                            />
                            <span>{item.name}</span>
                          </button>
                        ))}
                      </div>
                      {/* Search by Size View */}
                      <div className={styles.formGrid}>
                        <div className={styles.inputGroup}>
                          <label className={styles.inputLabel}>
                            WIDTH (MM)
                          </label>
                          <select
                            value={width?.code || ""}
                            onChange={(e) => {
                              const selected =
                                widthOptions.find(
                                  (o) => String(o.code) === e.target.value,
                                ) || null;
                              setWidth(selected);
                            }}
                            className={styles.selectInput}
                          >
                            <option value="">Select Width</option>
                            {widthOptions.map((option) => (
                              <option key={option.code} value={option.code}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className={styles.inputGroup}>
                          <label className={styles.inputLabel}>
                            ASPECT (%)
                          </label>
                          <select
                            value={profile?.code || ""}
                            onChange={(e) => {
                              const selected =
                                profileOptions.find(
                                  (o) => String(o.code) === e.target.value,
                                ) || null;
                              setProfile(selected);
                            }}
                            className={styles.selectInput}
                          >
                            <option value="">Select Profile</option>
                            {profileOptions.map((option) => (
                              <option key={option.code} value={option.code}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className={styles.inputGroup}>
                          <label className={styles.inputLabel}>
                            RIM DIAMETER (R)
                          </label>
                          <select
                            value={rim?.code || ""}
                            onChange={(e) => {
                              const selected =
                                rimOptions.find(
                                  (o) => String(o.code) === e.target.value,
                                ) || null;
                              setRim(selected);
                            }}
                            className={styles.selectInput}
                          >
                            <option value="">Select Rim</option>
                            {rimOptions.map((option) => (
                              <option key={option.code} value={option.code}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  <button type="submit" className={styles.submitBtn}>
                    Find Matches
                  </button>
                </form>
              </div>
            </div>
          )}
        </section>
      )}
    </>
  );
}
